import React, { Fragment, useEffect, useState } from "react";
import { useAuth } from "../utils/auth";
import { sdkWrapperURL } from "../utils/api-url-list";
import LoadingScreen from "../components/LoadingScreen";
import { ReactComponent as NextArrow } from "../assets/icons/next-icon.svg";
import { ReactComponent as Left } from "../assets/icons/BackArrow.svg";
import { ReactComponent as Right } from "../assets/icons/Right.svg";
import { Dialog, Transition } from "@headlessui/react";

const AppointmentList = () => {
  const {
    getToken,
    userData: { profile_id },
  } = useAuth();
  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [reason, setReason] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const token = await getToken();
        const dataResp = await fetch(
          sdkWrapperURL("/users/list/user-appointments"),
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
            body: JSON.stringify({
              table_config_page_no: page,
              table_config_rows_per_page: 15,
            }),
          }
        );
        const dataRespJSON = await dataResp.json();
        if (dataRespJSON?.statusCode?.toString().startsWith("2")) {
          setUserList(dataRespJSON.body);
          const total = Math.ceil(
            dataRespJSON.total_rows_count / dataRespJSON.rows_per_page
          );
          setTotalPages(total);
        } else throw new Error(dataRespJSON.message);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    })();
  }, [getToken, page]);

  return loading ? (
    <LoadingScreen style={{ minHeight: "60vh" }} />
  ) : (
    <div>
      {userList?.map?.((user, index) => (
        <div
          key={index}
          className="mt-5 py-3 px-4 grid grid-cols-2 gap-2 rounded-xl bg-white"
        >
          <div>
            <p className="text-black text-xs font-semibold">Date and Time:</p>
            <p className="text-secondary  text-xs font-normal">
              {new Date(`${user.appointment_date}`).toLocaleString(undefined, {
                weekday: "short",
                month: "short",
                day: "numeric",
                hour12: false,
              })}{" "}
              {user.start_time
                ? user.start_time.split(":").slice(0, 2).join(":")
                : ""}
            </p>
          </div>
          <div>
            <p className="text-black text-xs font-semibold">Status:</p>
            <p className="text-secondary text-xs font-normal">
              {user.current_status === 9
                ? "Approved"
                : user.current_status === 10
                ? "Rescheduled"
                : user.current_status === 11
                ? "Rejected"
                : user.current_status === 12
                ? "Acknowledged"
                : "Request Raised"}
            </p>
          </div>
          <div>
            <p className="mt-2 text-black text-xs font-semibold">
              Appointment With
            </p>
            <p className="text-secondary text-xs font-normal">
              {user.doctor_name}
            </p>
          </div>
          <button
            type="button"
            onClick={() => setReason(user.reason)}
            className="place-self-end mt-2 flex items-center text-left text-secondary text-xs font-semibold"
          >
            <span>Requested Reason</span>
            <NextArrow className="shrink-0 w-3 h-3 ml-2 text-secondary" />
          </button>
          {user?.current_status === 10 && (
            <p className="col-span-full my-1 text-xxs text-secondary">{`Note: ${user.rescheduled_msg}`}</p>
          )}
        </div>
      ))}
      <div className="flex justify-center items-center gap-4 mt-4">
        <button disabled={page === 1} onClick={() => setPage(page - 1)}>
          <Left className="h-5 w-5 text-secondary" />
        </button>
        <span className="text-sm text-gray-700">
          Page {page} of {totalPages}
        </span>
        <button
          disabled={page === totalPages}
          onClick={() => setPage(page + 1)}
        >
          <Right className="h-8 w-8 text-secondary" />
        </button>
      </div>
      <Transition show={reason.length > 0} as={Fragment}>
        <Dialog
          open={reason.length > 0}
          onClose={() => setReason("")}
          className="relative z-50"
          as={Fragment}
        >
          <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
            <Transition.Child
              className="fixed inset-0 bg-primary/70 flex items-center justify-center"
              enter="duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="duration-300 delay-150"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Transition.Child
                as={Fragment}
                enter="delay-150 duration-200"
                enterFrom="opacity-0 scale-50"
                enterTo="opacity-100 scale-100"
                leave="duration-100"
                leaveFrom="opacity-50 scale-50"
                leaveTo="opacity-0 scale-0"
              >
                <Dialog.Panel className="w-11/12 bg-white rounded-xl p-5 flex flex-col text-center">
                  <Dialog.Title className="text-left font-semibold">
                    Requested Reason:
                  </Dialog.Title>
                  <Dialog.Description className="mt-4 text-secondary text-xs font-normal">
                    {reason}
                  </Dialog.Description>
                  <div className="flex gap-4">
                    <button
                      onClick={() => setReason("")}
                      className="flex items-center justify-center space-x-2 mt-6 w-full rounded-full outline-none px-5 py-2.5 bg-gradient disabled:bg-secondary text-white"
                    >
                      Ok
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default AppointmentList;
